import { graphql } from 'src/gql';

import { useQueryWithErrorLogging } from '@savvy/graphql-hooks/useQueryWithErrorLogging';

import type { HouseholdMembershipRole } from '../constants/household-membership-role';
import { isValidHouseholdMembershipRole } from '../constants/household-membership-role';
import { useFlagsAndLoadingState } from '../contexts/launch-darkly-flags-ready-context';

const ViewerActiveHouseholdRoleQuery = graphql(/* GraphQL */ `
  query ViewerActiveHouseholdRole {
    currentUser {
      user {
        id
        activeHousehold {
          id
          viewerMembership {
            id
            role
          }
        }
      }
    }
  }
`);

export type UseHouseholdRoleResult = {
  readonly role: HouseholdMembershipRole | null;
  readonly loading: boolean;
};

export function useHouseholdRole(): UseHouseholdRoleResult {
  const { flagsReady } = useFlagsAndLoadingState();
  const skip = !flagsReady;

  const { data, loading } = useQueryWithErrorLogging(ViewerActiveHouseholdRoleQuery, { skip });

  if (!flagsReady || loading) {
    return { role: null, loading: true };
  }

  const rawRole = data?.currentUser.user?.activeHousehold?.viewerMembership?.role;
  const role = typeof rawRole === 'string' && isValidHouseholdMembershipRole(rawRole) ? rawRole : null;

  return { role, loading: false };
}
